import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Banner } from '../models/banner-ad';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  // private bannerCollection: AngularFirestoreCollection<Banner>
  // baseUrl: 'https://apis.ozmlabs.com',
  // baseUrl="https://osm-devuseast1-api.com";
  private bannerCollection: any = [];
  // baseUrl = 'https://pp0lzv5otc.execute-api.us-east-1.amazonaws.com/dev';
  baseUrl = 'https://q2q37adaxi.execute-api.us-east-1.amazonaws.com/osm-devuseast1-blue-apistage';

  constructor(private http: HttpClient) {
    const today = new Date();
    // this.bannerCollection = this.afs.collection('bannerAd')
    this.bannerCollection = [];
  }

  public getBanners(): Observable<Banner[]> {
    return this.bannerCollection;
  }

  public getBanners1(): Observable<any> {
    var data = {};
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     Accept: 'application/json',
    //   }),
    // };
    return this.http.get(this.baseUrl+"/banner/admin/list",{})
  }
}
